import dayjs from 'dayjs';

import { FirebaseImage, SelectOption } from 'types';

export const megabytesToBytes = (value: number) => value * 1000000;

export const getCurrentWeek = () => {
  const currentDate = dayjs();

  currentDate.hour(0);
  currentDate.minute(0);
  currentDate.second(0);

  return {
    start: currentDate.startOf('week'),
    end: currentDate.endOf('week'),
  };
};

export const getFullName = (
  firstName?: string,
  lastName?: string,
  placeholder = '-/-'
) => {
  if (firstName && lastName) return `${firstName} ${lastName}`;
  if (firstName) return firstName;
  if (lastName) return lastName;
  return placeholder;
};

export const createSelectOptions = (data: string[]): SelectOption[] => {
  return data.map((item) => ({ value: item, label: item }));
};

export const getCountersValue = (counters?: any[]) => {
  return counters && counters.length > 0 ? String(counters.length) : '-/-';
};

export const getThumbnailFromPhotos = (photos?: FirebaseImage[]) => {
  if (photos && photos.length > 0) {
    const photo = photos[0];
    return photo.thumbnail || photo.original;
  }

  return undefined;
};
